import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import i18n from "../../shared/i18n/i18n";
import Toasts from "../../shared/toasts";
import ModalManager from "../../shared/modal";
import Modal_Confirm_Delete from "../../shared/components/modal_confirm_delete";
import Modal_Self_Enrolment_Expiry_Edit from "./modal_self_enrolment_expiry_edit";
import Modal_Reminder_Edit from "./modal_reminder_edit";
import Auth from "../../shared/auth";
import RouterService from "../../shared/services/router.service";
import CategoryTag from "../../shared/components/component_category_tag";

let saving = false;
let deleting = false;
let course = null;
let lastSavedFirstReminder = null;
let lastSavedSecondReminder = null;
let lastSavedThirdReminder = null;

function toggleIsActive() {
    Requester.post(Gateway.admin + "courses/" + (course.isActive ? "deactivate" : "activate"), [course.id])
        .then(function () {
            course.isActive = !course.isActive;
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        });
}

function toggleHideIfNotEnrolled() {
    Requester.post(Gateway.admin + "courses/" + course.id + "/toggle-visibility")
        .then(function () {
            course.hideIfNotEnrolled = !course.hideIfNotEnrolled;
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        });
}

function toggleAllowSelfEnrolment() {
    Requester.post(Gateway.admin + "courses/" + course.id + "/toggle-self-enrolment")
        .then(function (courseResponse) {
            course.allowSelfEnrolment = courseResponse.allowSelfEnrolment;
            course.selfEnrolmentExpires = courseResponse.selfEnrolmentExpires;
            course.selfEnrolmentExpiryDays = courseResponse.selfEnrolmentExpiryDays;
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        }).finally(function () {
        m.redraw();
    });
}

function toggleAllowSelfEnrolmentExpiry() {
    if (saving) return;

    saving = true;
    m.redraw();

    Requester.post(Gateway.admin + "courses/" + course.id + "/toggle-self-enrolment-expiry")
        .then(function (courseResponse) {
            course.selfEnrolmentExpires = !course.selfEnrolmentExpires;
            // Reset when toggling off
            course.allowSelfEnrolment = courseResponse.allowSelfEnrolment;
            course.selfEnrolmentExpires = courseResponse.selfEnrolmentExpires;
            course.selfEnrolmentExpiryDays = courseResponse.selfEnrolmentExpiryDays;
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            saving = false;
            m.redraw();
        });
}

function openEditExpiryDaysModal() {
    ModalManager.open(
        i18n.t("edit_self_enrolment_expiry_days"),
        [],
        Modal_Self_Enrolment_Expiry_Edit,
        {
            courseId: course.id,
            days: course.selfEnrolmentExpiryDays,
            lastSavedFirstReminder: lastSavedFirstReminder,
            lastSavedSecondReminder: lastSavedSecondReminder,
            lastSavedThirdReminder: lastSavedThirdReminder,
            callback: function(courseResponse) {
                course.selfEnrolmentExpiryDays = courseResponse.selfEnrolmentExpiryDays;
                course.selfEnrolmentExpiryReminder = courseResponse.selfEnrolmentExpiryReminder;
                course.selfEnrolmentExpiryFirstReminder = courseResponse.selfEnrolmentExpiryFirstReminder;
                course.selfEnrolmentExpirySecondReminder = courseResponse.selfEnrolmentExpirySecondReminder;
                course.selfEnrolmentExpiryThirdReminder = courseResponse.selfEnrolmentExpiryThirdReminder;
                lastSavedFirstReminder = courseResponse.selfEnrolmentExpiryFirstReminder;
                lastSavedSecondReminder = courseResponse.selfEnrolmentExpirySecondReminder;
                lastSavedThirdReminder = courseResponse.selfEnrolmentExpiryThirdReminder;
                m.redraw();
            }
        }
    );
}

function getExpiryDaysDisplayText() {
    const days = course.selfEnrolmentExpiryDays;

    if (days == null || days === "") {
        return i18n.t("expiry_not_set");
    }

    const dayLabel = days <= 1 ? i18n.t("day") : i18n.t("days");
    return i18n.t("current") + ": " + days + " " + dayLabel;
}

function getExpiryButtonText() {
    const days = course.selfEnrolmentExpiryDays;
    const hasValue = days != null && days !== "";
    return hasValue ? i18n.t("change_expiry_period") : i18n.t("set_expiry_period");
}

function toggleSelfEnrolmentReminder() {
    if (saving || !(course.selfEnrolmentExpiryDays >= 0)) return;

    saving = true;
    m.redraw();

    Requester.post(Gateway.admin + "courses/" + course.id + "/toggle-self-enrolment-expiry-reminder")
        .then(function (courseResponse) {
            course.selfEnrolmentExpiryDays = courseResponse.selfEnrolmentExpiryDays;
            course.selfEnrolmentExpiryReminder = courseResponse.selfEnrolmentExpiryReminder;
            course.selfEnrolmentExpiryFirstReminder = courseResponse.selfEnrolmentExpiryFirstReminder;
            course.selfEnrolmentExpirySecondReminder = courseResponse.selfEnrolmentExpirySecondReminder;
            course.selfEnrolmentExpiryThirdReminder = courseResponse.selfEnrolmentExpiryThirdReminder;
            lastSavedFirstReminder = courseResponse.selfEnrolmentExpiryFirstReminder;
            lastSavedSecondReminder = courseResponse.selfEnrolmentExpirySecondReminder;
            lastSavedThirdReminder = courseResponse.selfEnrolmentExpiryThirdReminder;
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response?.properties?.errorCode || "unknown_error"));
        })
        .finally(function () {
            saving = false;
            m.redraw();
        });
}

// Helper functions for first reminder
function openSetReminderScheduleModal() {
    ModalManager.open(
        i18n.t("set_reminder_schedule"),
        [],
        Modal_Reminder_Edit,
        {
            course: course,
            days: course.selfEnrolmentExpiryFirstReminder,
            reminderNumber: "First",
            upperBound: course.selfEnrolmentExpiryDays + 1,
            upperErrorKey: "reminder_exceeds_expiry",
            callback: function(courseResponse) {
                course.selfEnrolmentExpiryDays = courseResponse.selfEnrolmentExpiryDays;
                course.selfEnrolmentExpiryReminder = courseResponse.selfEnrolmentExpiryReminder;
                course.selfEnrolmentExpiryFirstReminder = courseResponse.selfEnrolmentExpiryFirstReminder;
                course.selfEnrolmentExpirySecondReminder = courseResponse.selfEnrolmentExpirySecondReminder;
                course.selfEnrolmentExpiryThirdReminder = courseResponse.selfEnrolmentExpiryThirdReminder;
                lastSavedFirstReminder = courseResponse.selfEnrolmentExpiryFirstReminder;
                lastSavedSecondReminder = courseResponse.selfEnrolmentExpirySecondReminder;
                lastSavedThirdReminder = courseResponse.selfEnrolmentExpiryThirdReminder;
                m.redraw();
            }
        }
    );
}

function getReminderDisplayText() {
    const days = [
        course.selfEnrolmentExpiryFirstReminder,
        course.selfEnrolmentExpirySecondReminder,
        course.selfEnrolmentExpiryThirdReminder
    ].filter(d => d !== null && d !== undefined);

    const format = (d) => d > 1 ? `${d} ${i18n.t("days_before")}` : `${d} ${i18n.t("day_before")}`;

    if (days.length === 0) return `${i18n.t("reminder_not_set")}`;

    if (days.length === 1) return format(days[0]);

    if (days.length === 2) {
        return `${format(days[0])} and ${format(days[1])}`;
    }

    return `${format(days[0])}, ${format(days[1])} and ${format(days[2])}`;
}

function getFirstReminderButtonText() {
    const days = course.selfEnrolmentExpiryFirstReminder;
    const hasValue = days != null && days !== "";
    return hasValue ? i18n.t("change_reminder") : i18n.t("set_reminder");
}


function getSecondReminderDisplayText() {
    const days = course.selfEnrolmentExpirySecondReminder;
    if (days == null || days === "") {
        return i18n.t("reminder_not_set");
    }
    const dayLabel = days <= 1 ? i18n.t("day_before") : i18n.t("days_before");
    return i18n.t("current") + ": " + days + " " + dayLabel;
}

function getThirdReminderDisplayText() {
    const days = course.selfEnrolmentExpiryThirdReminder;
    if (days == null || days === "") {
        return i18n.t("reminder_not_set");
    }
    const dayLabel = days <= 1 ? i18n.t("day_before") : i18n.t("day_before");
    return i18n.t("current") + ": " + days + " " + dayLabel;
}

function toggleAllowReEnrolment() {
    Requester.post(Gateway.admin + "courses/" + course.id + "/toggle-re-enrolment")
        .then(function () {
            course.allowReEnrolment = !course.allowReEnrolment;
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        });
}

function toggleAllowGuests() {
    Requester.post(Gateway.admin + "courses/" + course.id + "/toggle-guest-enrolment")
        .then(function () {
            course.allowGuestEnrolment = !course.allowGuestEnrolment;
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        });
}

function toggleAllowNonSequentialAccess() {
    Requester.post(Gateway.admin + "courses/" + course.id + "/toggle-non-sequential")
        .then(function () {
            course.allowNonSequentialAccess = !course.allowNonSequentialAccess;
            Toasts.add("success", i18n.t("saved_changes"), "");
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        });
}

function confirmDeleteCourse() {
    ModalManager.open(i18n.t("delete_course"), [], Modal_Confirm_Delete, {callback: deleteCourse});
}

function deleteCourse() {
    deleting = true;
    Requester.delete(Gateway.admin + "courses/" + course.id)
        .then(function () {
            RouterService.navigateToCourses();
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            deleting = false;
        });
}

const Component_Course_Settings = {
    oninit: function (vnode) {
        course = vnode.attrs.course;
        // Store initial values for resetting on validation failure
        lastSavedFirstReminder = course.selfEnrolmentExpiryFirstReminder ?? null;
        lastSavedSecondReminder = course.selfEnrolmentExpirySecondReminder ?? null;
        lastSavedThirdReminder = course.selfEnrolmentExpiryThirdReminder ?? null;
    },
    view: function () {
        return [
            m(".content-box", [
                course.categories && course.categories.length > 0 ? m(".course-info-section pb-2 mb-3 flex-row justify-between", [
                    m(".mr-2", [
                        m(".text-bolder", i18n.t("categories")),
                        m("div.mt-1", course.categories.map(function(cat) {
                            return cat.isEditable
                                ? m(CategoryTag, {key: cat.id || cat.name, class: "category-custom", label: cat.name})
                                : m(CategoryTag, {key: cat.name, class: !!cat.name ? cat.name.replace(/\s+/g, "-").toLocaleLowerCase() : "", label: i18n.t("category_" + cat.name.replace(/\s+/g, "_").toLocaleLowerCase())});
                        }))
                    ])
                ]) : "",
                m(".form bordered-sections", {class: !Auth.validateRights(["courses_edit_settings"]) ? "disabled" : ""}, [

                    m(".form-section flex-row justify-between", [
                        m(".mr-2", [
                            m(".text-bolder", i18n.t("active")),
                            m("div", i18n.t("essentially_an_on_off_switch_for_the_course"))
                        ]),
                        m(".btn btn-toggle", {onclick: toggleIsActive, class: course.isActive ? "active" : ""})
                    ]),
                    m(".form-section flex-row justify-between", [
                        m(".mr-2", [
                            m(".text-bolder", i18n.t("hide_if_not_enrolled")),
                            m("div", i18n.t("only_show_this_course_in_the_library_to_users_who_are_enrolled"))
                        ]),
                        m(".btn btn-toggle", {
                            onclick: toggleHideIfNotEnrolled,
                            class: course.hideIfNotEnrolled ? "active" : ""
                        })
                    ]),
                    m(".form-section flex-row justify-between", [
                        m(".mr-2", [
                            m(".text-bolder", i18n.t("allow_self_enrolment")),
                            m("div", i18n.t("allow_self_enrolment_tip"))
                        ]),
                        m(".btn btn-toggle", {
                            onclick: toggleAllowSelfEnrolment,
                            class: course.allowSelfEnrolment ? "active" : ""
                        })
                    ]),
                    course.allowSelfEnrolment ?
                        m(".form-section flex-row justify-between", [
                            m(".mr-2", [
                                m(".text-bolder", i18n.t("allow_self_enrolment_expiry")),
                                m("div", {
                                    class: "text-sm " + (course.selfEnrolmentExpires ? "" : "text-gray")
                                }, i18n.t("allow_self_enrolment_expiry_tip")),
                                course.selfEnrolmentExpires ? [
                                    m(".m-1", m(".text-bolder", i18n.t("expiry_period"))),
                                    m(".m-1", m("span", getExpiryDaysDisplayText()))
                                ] : ""
                            ]),
                            m(".right-side", [
                                m(".btn.btn-toggle", {
                                    onclick: toggleAllowSelfEnrolmentExpiry,
                                    class: course.selfEnrolmentExpires ? "active" : "",
                                    disabled: saving
                                }),
                                course.selfEnrolmentExpires ?
                                    m("button.btn.btn-info", {
                                        onclick: openEditExpiryDaysModal,
                                        disabled: saving,
                                        style: "display: flex; align-items: center; gap: 8px;"
                                    }, m("span", getExpiryButtonText())) : ""
                            ])
                        ]) : '',
                    course.allowSelfEnrolment && course.selfEnrolmentExpires ?
                        m(".form-section",
                            [m(".form-section flex-row justify-between", [
                                m(".mr-2", [
                                    m(".text-bolder", i18n.t("self_enrolment_reminder")),
                                    m("div", {
                                        class: "text-sm " + (course.selfEnrolmentExpiryReminder ? "" : "text-gray")
                                    }, i18n.t("self_enrolment_reminder_tip"))
                                ]),
                                m(".right-side mb-1", [
                                    m(".btn.btn-toggle", {
                                        onclick: toggleSelfEnrolmentReminder,
                                        class: course.selfEnrolmentExpiryReminder ? "active" : "",
                                        disabled: saving || !(course.selfEnrolmentExpiryDays >= 0)
                                    })])
                            ]),
                                [
                                    course.selfEnrolmentExpiryReminder && course.selfEnrolmentExpiryDays >= 0  ? [
                                        // First Reminder
                                        m(".form-section flex-row justify-between mt-2", [
                                            m(".mr-2", [
                                                m(".text-bolder text-sm", i18n.t("reminder_schedule")),
                                                m(".m-1", m("span.text-sm", getReminderDisplayText()))
                                            ]),
                                            m(".right-side", [
                                                m("button.btn.btn-info btn-sm", {
                                                    onclick: openSetReminderScheduleModal,
                                                    disabled: saving,
                                                    style: "display: flex; align-items: center; gap: 8px;"
                                                }, m("span", getFirstReminderButtonText()))
                                            ])
                                        ]),
                                    ] : null
                                ]])
                        : '',
                    m(".form-section flex-row justify-between", [
                        m(".mr-2", [
                            m(".text-bolder", i18n.t("allow_reenrolment")),
                            m("div", i18n.t("allow_reenrolment_tip"))
                        ]),
                        m(".btn btn-toggle", {
                            onclick: toggleAllowReEnrolment,
                            class: course.allowReEnrolment ? "active" : ""
                        })
                    ]),
                    m(".form-section flex-row justify-between", [
                        m(".mr-2", [
                            m(".text-bolder", i18n.t("allow_non_sequential_unit_access")),
                            m("div", i18n.t("allow_units_in_this_course_to_be_accessed_in_any_order"))
                        ]),
                        m(".btn btn-toggle", {
                            onclick: toggleAllowNonSequentialAccess,
                            class: course.allowNonSequentialAccess ? "active" : ""
                        })
                    ]),
                    m(".form-section flex-row justify-between", [
                        m(".mr-2", [
                            m(".text-bolder", i18n.t("allow_guest_enrolment")),
                            m("div", i18n.t("allow_guest_enrolment_tip"))
                        ]),
                        m(".btn btn-toggle", {
                            onclick: toggleAllowGuests,
                            class: course.allowGuestEnrolment ? "active" : ""
                        })
                    ])
                ])
            ]),
            Auth.validateRights(["courses_delete"], [
                m(".content-box", [
                    !deleting && !saving ? m("button.btn-error", {onclick: confirmDeleteCourse}, i18n.t("delete_course")) : m("button.btn-text no-click text-error", [i18n.t("deleting"), m(".loading-dots")])
                ])
            ])
        ];
    }
};
export default Component_Course_Settings;
